import { Region } from './region.model';
import moment from 'moment';

export class ApiCourseUpdate {
    course_id: number;
    name: string;
    description: string;
    ahec_id: number;
    budget_discipline_id: number;
    type_id: number;
    status_id: number;
    structure_id: number;
    calendar_scope_id: number;
    start_date: string;
    end_date: string;
    olr_ready: string;
    olc_ready: string;
    use_advanced_olr: number;
    attend_estimate: number;
    reporting_contact_hours: number;
    reporting_exclusion: number;
    suppress_cpd: number;
    contact_person_id: number;
    contact_phone: string;
    brochure_url: string;
    internal_comment: string;
    purpose_goals: string;
    topic_keywords: string;
    target_audience: string;
    registration: number;
    calendarReminder: string;
    image_id: number;
    track_selection_required;
    reporting_headcount;
    cipe_event;
    multi_ahec_event;
    reporting_crosstab_header;
    pars_sponsorship;
    addl_revenue_amount;
    vendor_revenue_amount;
    meals_cost;
    breaks_cost;
    misc_food_cost;
    brochure_count;
    brochure_mail;
    brochure_presort;
    brochure_print_total;
    brochure_misc_amount;
    facility_rental;
    facility_rental_per_attend;
    honoraria_amount;
    travel_guests;
    pay_support_staff;
    pay_prof_staff;
    ceu_credit;
    av_services;
    supplies;
    tags = {regions: [], statewide: []};
    show_lms_open: boolean;
    join_url: string;
    landing_page: boolean;
    landing_page_image_id: number;
    welcome_message: string;
    accme_activity_id: string;

    constructor(data) {
        if (data.id) this.course_id = data.id ? data.id : null;
        this.name = data.name;
        this.description = data.description != null ? data.description : "";
        this.ahec_id = data.region != null ? data.region : "";
        this.budget_discipline_id = data.budgetDiscipline != null ? data.budgetDiscipline : "";
        this.type_id = data.type_id ? data.type_id : "";
        this.status_id = data.status != null ? data.status : "";
        this.structure_id = data.structure != null ? data.structure : "";
        this.calendar_scope_id = data.calendarScope != null ? data.calendarScope : "";
        this.start_date = data.startDate != null && moment(data.startDate).isValid() ? moment(data.startDate).format('YYYY-MM-DD HH:mm:ss') : "";
        this.end_date = data.endDate != null && moment(data.endDate).isValid() ? moment(data.endDate).format('YYYY-MM-DD HH:mm:ss') : "";
        this.olr_ready = data.olrReady ? 'Y' : 'N';
        this.olc_ready = data.olcReady ? 'Y' : 'N';
        this.use_advanced_olr = data.useAdvancedOlr ? 1 : 0;
        this.attend_estimate = data.attendEstimate != null ? data.attendEstimate : 0;
        this.reporting_contact_hours = data.reportingContactHours != null ? data.reportingContactHours : 0;
        this.reporting_exclusion = data.reportingExclusion ? 1 : 0;
        this.suppress_cpd = data.suppressCPDRecord ? 1 : 0;
        this.contact_person_id = data.contactPerson ? data.contactPerson : "";
        this.contact_phone = data.contactPhone != null ? data.contactPhone : "";
        this.brochure_url = data.brochureUrl != null ? data.brochureUrl : "";
        this.internal_comment = data.internalComment != null ? data.internalComment : "";
        this.purpose_goals = data.purposeGoals != null ? data.purposeGoals : "";
        this.topic_keywords = data.topicKeywords != null ? data.topicKeywords : "";
        this.target_audience = data.targetAudience != null ? data.targetAudience : "";
        this.registration = data.registration ? 1 : 0;
        this.calendarReminder = data.calendarReminder != null ? data.calendarReminder : "";
        this.image_id = data.image != null ? data.image.id : '';
        this.track_selection_required = data.trackSelectionRequired ? data.trackSelectionRequired : 0;
        this.reporting_headcount = data.reportingHeadcount ? data.reportingHeadcount : 0;
        this.cipe_event = data.cipeEvent ? data.cipeEvent : 0;
        this.multi_ahec_event = data.multiAhecEvent ? data.multiAhecEvent : 0;
        this.reporting_crosstab_header = data.reportingCrosstabHeader ? data.reportingCrosstabHeader : "";
        this.pars_sponsorship = data.parsSponsorship ? data.parsSponsorship : "Direct";
        this.addl_revenue_amount = data.addl_revenue_amount ? data.addl_revenue_amount : 0;
        this.vendor_revenue_amount = data.vendor_revenue_amount !== null ? data.vendor_revenue_amount : 0;
        this.meals_cost = data.meals_cost !== null ? data.meals_cost : 0;
        this.breaks_cost = data.breaks_cost !== null ? data.breaks_cost : 0;
        this.misc_food_cost = data.misc_food_cost !== null ? data.misc_food_cost : 0;
        this.brochure_count = data.brochure_count !== null ? data.brochure_count : 0;
        this.brochure_mail = data.brochure_mail !== null ? data.brochure_mail : 0;
        this.brochure_presort = data.brochure_presort !== null ? data.brochure_presort : 0;
        this.brochure_print_total = data.brochure_print_total !== null ? data.brochure_print_total : 0;
        this.brochure_misc_amount = data.brochure_misc_amount !== null ? data.brochure_misc_amount : 0;
        this.facility_rental = data.facility_rental !== null ? data.facility_rental : 0;
        this.facility_rental_per_attend = data.facility_rental_per_attend !== null ? data.facility_rental_per_attend : 0;
        this.honoraria_amount = data.honoraria_amount !== null ? data.honoraria_amount : 0;
        this.travel_guests = data.travel_guests !== null ? data.travel_guests : 0;
        this.pay_support_staff = data.pay_support_staff !== null ? data.pay_support_staff : 0;
        this.pay_prof_staff = data.pay_prof_staff !== null ? data.pay_prof_staff : 0;
        this.ceu_credit = data.ceu_credit !== null ? data.ceu_credit : 0;
        this.av_services = data.av_services !== null ? data.av_services : 0;
        this.supplies = data.supplies !== null ? data.supplies : 0;
        this.tags.regions = data.tagRegions != null ? Object.values(data.tagRegions) : null;
        this.tags.statewide = data.tagStatewide != null ? Object.values(data.tagStatewide) : null;
        this.show_lms_open = data.showLmsOpen != null ? data.showLmsOpen : 0;
        if (data.joinUrl) this.join_url = data.joinUrl;
        this.landing_page = data.landingPage;
        this.landing_page_image_id = data.landingPageImage != null ? data.landingPageImage.id : '';
        if (data.welcomeMessage) this.welcome_message = data.welcomeMessage;
        this.accme_activity_id = data.accmeActivityID ? data.accmeActivityID: '';
    }
}
